/* eslint-disable react/no-array-index-key */
/* eslint-disable operator-linebreak */
import { useMemo } from 'react';
import { NavigationMenu } from '../desktop-navigation/navigation-menu';
import { NavigationMenuItem } from '../desktop-navigation/navigation-menu-item';
import { AppNavigationItem, NavigationItemType } from '../types';

export function CollapseDesktopMenu({ items }: { items: AppNavigationItem[] }) {
    const collapsedItems = useMemo(() => items
        .filter((item) => item.collapse)
        .map((item) => {
            if (item.dropdownItems === undefined) {
                return [{
                    to: item.to,
                    title: item.title,
                    type: item.type,
                }];
            }
            return item.dropdownItems.map((subItem) => ({
                to: subItem.to,
                title: subItem.title,
                type: subItem.type,
            }));
        })
        .flat(), [items]);

    return (
        <NavigationMenu label="More">
            {collapsedItems.map((subMenuItem, index) => (
                <NavigationMenuItem
                    key={index}
                    to={subMenuItem.to}
                    label={subMenuItem.title}
                    isExternal={subMenuItem.type === NavigationItemType.ExternalLink}
                />
            ))}
        </NavigationMenu>
    );
}
